import Util from '../../../lib/util.jsx'
import moment from 'moment'

const getNextTargetTime = timer => {
  if (!timer.TimeCard()) {
    return null
  }

  // Extra Date object is to suppress the Moment deprecation warning: http://momentjs.com/guides/#/warnings/js-date/
  return moment.utc(new Date(timer.TimeCard().createdOn))
    .add(1, 'days')
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .toDate()
}

// This is now in the frontend and has been slightly refactored,
// keeping in mind that we want to remove this function and handle
// it in the backend as part of ROD-1202
const shouldStopAndCreateNewTimeCard = (timer, timerTakenSeconds) => {
  if (timer.TimeCard() && timer.TimeCard().timeTaken) {
    timerTakenSeconds += timer.TimeCard().timeTaken * 60
  }

  const minutesInADay = 1440
  if (timerTakenSeconds / 60 >= minutesInADay) {
    return true
  }

  const nextTargetTime = getNextTargetTime(timer)
  // Should be a valid date
  if (!nextTargetTime || isNaN(nextTargetTime.getTime())) {
    return false
  }

  const currDate = new Date().getTime()
  const targetTime = nextTargetTime.getTime()

  if (currDate >= targetTime) {
    return true
  }

  return false
}

const getTextAndSeconds = (timerSeconds, timeSpent) => {
  const timerTakenSeconds = timerSeconds + timeSpent * 60
  const timeTakenText = Util.convertMinutesToHour(timerTakenSeconds / 60)
  const seconds = `0${timerTakenSeconds % 60}`.substr(-2)

  return { timeTakenText, seconds }
}

const calculateElapsedSeconds = (startTime, endTime) => {
  const start = startTime ? new Date(startTime) : new Date().getTime()
  const end = endTime ? new Date(endTime) : new Date().getTime() + 1

  return Math.round(Math.abs(end - start) / 1000)
}

export {
  getNextTargetTime,
  shouldStopAndCreateNewTimeCard,
  getTextAndSeconds,
  calculateElapsedSeconds
}
